import React from 'react'
import cn from 'classnames'
import styled from '@emotion/styled'
import { Dropdown } from 'shared/ui'
import {
  ArrowDown,
  ArrowUpDown,
} from '@groovehq/internal-design-system/lib/assets/icons'

class SortMenu extends React.PureComponent {
  state = { isOpen: false }

  open = () => {
    this.setState({ isOpen: true })
  }

  close = () => {
    this.setState({ isOpen: false })
  }

  get sortOrderText() {
    const { options } = this.props

    const selectedOptionText = (options || []).find(x => x.active)
      ?.selectedOptionText

    return (
      <>
        <ArrowUpDown className="grui arrow-up-down" />
        {selectedOptionText || 'Sort By'}
        <ArrowDown className="caret" />
      </>
    )
  }

  render() {
    const { className, options } = this.props

    return (
      <Dropdown
        text={this.sortOrderText}
        className={cn('grui', className)}
        direction="right"
        header="Sorting"
        onClose={this.close}
        icon={null}
        options={options}
      />
    )
  }
}

SortMenu.displayName = 'SortMenu'

const Styled = styled(SortMenu)`
  &&& {
    color: ${props => props.theme.color.monochrome.dark};
    font-weight: ${props => props.theme.fontWeight.medium};
    user-select: none;
    z-index: 11;
    padding: 11px;
    height: 32px;
    display: flex;
    align-items: center;

    & > .text::before {
      content: '';
      display: block;
      opacity: 0;
      position: absolute;
      transition-duration: 0.15s;
      transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
      z-index: -1;
      bottom: 0;
      left: 0;
      right: 0;
      top: 0;
      background: ${props => props.theme.color.iconButton.backgroundHover};
      border-radius: 4px;
      transform: scale(0);
      transition-property: transform, opacity;
    }

    & > .text:hover::before {
      opacity: 1;
      transform: scale(1);
      color: ${props => props.theme.color.iconButton.textHover};
    }

    svg.caret {
      margin-left: 0.5em;
      font-size: 0.7em;
      top: 0;
    }

    svg.arrow-up-down > g {
      stroke-width: 1.3;
    }
  }
`

export default Styled
